const styles = {
  boxItemPg: {
    background:'#f1f1f1',padding:'10px'
  },
  descForma:{
    fontSize:'11px',fontWeight:'bold'
  },
  valuePg:{
    fontSize:'1.3em'
  },
  rmvPg:{
    fontSize:'13px',textAlign:'right'
  },
  boxTotalizador:{
    fontSize:'12px',marginBottom:'5px',fontWeight:'400'
  },
  valueTotalizador:{
    width:'100px',textAlign:'right',fontSize:'16px',float:'right'
  },
  boxPendencia:{
    fontSize:'15px',marginTop:'5px',marginBottom:'30px',fontWeight:'400'
  },
  valuePendencia:{
    width:'150px',textAlign:'right',fontSize:'20px',float:'right'
  },
  tCenter:{
    textAlign:"center"
  }
};
export default styles;